import { Slider } from "@reach/slider";
import * as React from "react";

export function SidebarSlider(p: {
  above: {
    label: string;
    value: string;
  };
  below: {
    row1: {
      label: string;
      value: string;
    };
    row2: {
      label: string;
      value: string;
    };
    row3: {
      label: string;
      value: string;
    };
  };
  setValue: (number) => void;
  value: number;
  min:number;
  max:number;
}) {
  // noinspection RequiredAttributes
  return (
    <div className="atc-sidebar-slider">
      <div className="atc-sidebar-slider__title">
        <span>{p.above.label}</span> - {p.above.value}
      </div>
      <div className="atc-sidebar-slider__slider">
        <div className="at-slider">
          <Slider
            value={p.value}
            onChange={e => {
              if (Math.abs(p.value - e) > 0.009) {
                p.setValue(e);
              }
            }}
            min={p.min}
            max={p.max}
            step={0.01}
          />
          <div className="at-slider__values">
            <span className="at-slider__value">{p.min*100}%</span>
            <span className="at-slider__value">{p.max*100}%</span>
          </div>
        </div>
      </div>
      <ul className="atc-sidebar-slider__list">
        <li className="atc-sidebar-slider__item">
          <span>{p.below.row1.label}</span>
          <span>{p.below.row1.value}</span>
        </li>
        <li className="atc-sidebar-slider__item">
          <span>{p.below.row2.label}</span>
          <span>{p.below.row2.value}</span>
        </li>
        <li className="atc-sidebar-slider__item">
          <span>{p.below.row3.label}</span>
          <span>{p.below.row3.value}</span>
        </li>
      </ul>
    </div>
  );
}
